import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-db2fba92"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "equipment-live"
};
var _hoisted_2 = {
  class: "siderbar"
};
var _hoisted_3 = ["onClick"];
var _hoisted_4 = {
  class: "num"
};
var _hoisted_5 = {
  class: "text"
};
var _hoisted_6 = {
  class: "content",
  id: "contentWrap"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_router_view = _resolveComponent("router-view");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.siderbar, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: _normalizeClass(["flex flex-column align-center justify-center siderbar-item", {
        active: _ctx.curSiderbarIndex === index
      }]),
      onClick: function onClick($event) {
        return _ctx.siderbarClick(index, item.factoryId);
      }
    }, [_createElementVNode("span", _hoisted_4, _toDisplayString(item.num), 1), _createElementVNode("span", _hoisted_5, _toDisplayString(item.typeName), 1)], 10, _hoisted_3);
  }), 128))]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_router_view)])]);
}